import {
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { FitterCommentsSheetComponent } from '@sc/ui-components';
import { ScreenUtils } from '@sc/utils';
import { FitterCommentsInputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-fitter-comments-bottom-sheet',
  styleUrls: ['./fitter-comments-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FitterCommentsSheetComponent],
  template: `
    <sc-fitter-comments-sheet
      [fitter]="data.fitter"
      [itineraryDistanceInMeters]="data.itineraryDistanceInMeters"
      [itineraryDurationInSeconds]="data.itineraryDurationInSeconds"
      (closeEvent)="onCloseSheet()"
    ></sc-fitter-comments-sheet>
  `,
})
export class FitterCommentsBottomSheetComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: FitterCommentsInputData,
    private readonly bottomSheetRef: MatBottomSheetRef<FitterCommentsBottomSheetComponent>
  ) {}

  ngOnInit(): void {
    // NOTE - For now, this component should never be used (so we close it directly), but it could be in the future
    this.onCloseSheet();
  }

  onCloseSheet() {
    this.bottomSheetRef.dismiss();
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    if (!ScreenUtils.isMobileResolution()) {
      this.onCloseSheet();
    }
  }
}
